import React, { useContext, createContext, useState } from 'react';

const PaymentConfirmedContext = createContext();

const PaymentConfirmedProvider = ({ children }) => {
    const [paymentConfirmedObject, setPaymentConfirmedObject] = useState({});

    return (
        <PaymentConfirmedContext.Provider value={{ paymentConfirmedObject, setPaymentConfirmedObject }}>
            {children}
        </PaymentConfirmedContext.Provider>
    );
};

const usePaymentConfirmedContext = () => useContext(PaymentConfirmedContext);

export { PaymentConfirmedProvider, usePaymentConfirmedContext };